import React from 'react'
import { Typography, Grid } from '@material-ui/core'
import LinkIcon from '@material-ui/icons/Link'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { StyledDivision, StyledPlanogramLinks } from '../styles'
import { svgIconStyle } from '../../../theme/Global'

const iconStyle = svgIconStyle({
  width: '22px',
  display: 'inline-block',
  position: 'relative',
  marginRight: '5px',
  top: '7px'
})

export const IppLink = ({ ippCode }) => {
  const IppURL = `${IPP_BASE_PATH}/#/${ippCode}`

  const handleCopy = () => {
    navigator.clipboard.writeText(IppURL)
  }

  const handleOpen = () => {
    window.open(IppURL, '_blank')
  }

  return (
    <Grid container style={{ marginTop: '10px' }}>
      <Grid item xs={12}>
        <Typography align="left">
          <StyledPlanogramLinks onClick={() => handleOpen()}>
            <OpenInNewIcon style={iconStyle} />
            Access IPP
          </StyledPlanogramLinks>
          <StyledDivision />
          <StyledPlanogramLinks onClick={() => handleCopy()}>
            <LinkIcon style={iconStyle} />
            Copy Link
          </StyledPlanogramLinks>
        </Typography>
      </Grid>
    </Grid>
  )
}
